require('./overflowHeader.less');

var DropDown = require('../../../../common/dropDown/dropDownContentView'),
    _ = require('underscore'),
    $ = require('jquery'),
    RotateView = require('../../../header/headerCenter/rotate/rotate'),
    DownLoadTemplate = require('./download.hbs'),
    RotateMenuTemplate = require('../../headerCenter/rotate/rotate.hbs'),
    HeaderCenterView = require('../../headerCenter/headerCenter');



/**
 * Find and Redact -- temporary flag to not show the full text menu items.
 * In the current design they can be disabled, but at least in Phase 1 we don't want them to appear at all.
 */

var HIDE_FULL_TEXT_MENU_ITEMS = 1;
if ( PRODUCTION ) {
    HIDE_FULL_TEXT_MENU_ITEMS =1;
}


module.exports = DropDown.extend({

    ROTATE_DISABLE_CLASS: 'disabled', /* used b/c hide doesn't work (in header) -- specificity, so use another class) */
    template: require('./headerOverflow.hbs'),

    templateOptions: function() {

        var vCh =  this.options.vChannel,
            documentHasPages = !vCh.request('activeDocHasNoPages'),
            allowDownloads = vCh.request('allowDownload'),
            allowDocDownloadPDF = vCh.request('allowDocumentDownload', 1),
            allowDocDownloadOriginal = vCh.request('allowDocumentDownload'),
            isMultiDoc = vCh.request('documents').length > 1;

        return _.extend({

            //  Disabling page menu items done in seperate fn

            downloadMenu: DownLoadTemplate({
                // disable: this is generic -- the underlying items are disabled individually
                // ( Note: not entirely correct -- eg only 1 URL page document -- DVBC-1704;
                // would really want if no 'downloadable PDF' or 'original pages' ,
                // but this isn't going to break anything -- all items will just be disabled )
                disable: !documentHasPages || !allowDownloads,

                disableDocDownloadPDF: !allowDocDownloadPDF,
                disableDocDownloadOriginal: !allowDocDownloadOriginal,
                titleAttribute: 'Download' + ( isMultiDoc ? ' Active Document' : '' )
            })

            },

            {
                showPDFComboSubMenu: vCh.request('allowPDFCombo'),
                documentHasPages: documentHasPages,
                disableLaunchDocAsPdf: !allowDocDownloadPDF, // utilize same logic as allowing document download as PDF
                disableNewWindow: !vCh.request('allowNewWindow'),
                disableDeletePage: !vCh.request('allowDeletePages'),
                disableAddPages: !vCh.request('allowAddPages'),
                disableReorderPages: !vCh.request('allowReorderPages'),
                rotateMenuItems: $(RotateMenuTemplate()).html(), //(html just gives the menu items)

                disbleShowPageText: !vCh.request('allowDocumentLevelShowPageText'),
                disableTextOnlyMode: !vCh.request('allowDocumentLevelTextOnlyMode'),


                hideFullTextMenuItems: HIDE_FULL_TEXT_MENU_ITEMS

            },

            HeaderCenterView.prototype.fullScreenTemplateOpts( !vCh.request('settings').fullScreen() )
        );


    },
    render: function() {

        DropDown.prototype.render.call(this); //create the dropdown first

        var vc = this.options.vChannel,
            nPgs = vc.request('activeDocPages').length,
            pgClass = ( nPgs > 1  ? 'multi' : (nPgs === 0 ? 'no' : 'one')  ) + '-' + 'pages';

        //TODO: in template
        this.$el.addClass( vc.request('viewMode') + '-mode' ).addClass(pgClass);

        //TODO: should really re-render from template on page change
        this.updatePostPageChange({
            isFirstPg:  vc.request('isFirstPage'),
            isLastPg: vc.request('isLastPage'),
            disableRotation: vc.request('disableRotation'),
            disableScaling: vc.request('disableScaling'),
            page: vc.request('currentPage')
        });

        return this;

    },
    ui: _.extend({

            showDocInfo: '.docInfo',
            showPgInfo: '.pgInfo',

            showPageText: '#mi-show-pg-text',
            textOnlyMode: '#mi-text-only-mode',

            zoomIn: '#zoom-in',
            zoomOut: '#zoom-out',
            popWindow: '.popWindow',
            nextPg: '.dd-next',
            prevPg: '.dd-prev',
            firstPg: '.dd-first',
            lastPg: '.dd-last',
            showAbout: '#FV-info',

            /* TODO -- subview, download */
            dlDocPDF: '#dn-dc-pdf',
            dlDocRaw: '#dn-dc-raw',
            dlPgPDF: '#dn-pg-pdf',
            dlPgRaw: '#dn-pg-raw',

            rotatePg: '.dd-rot-pg',
            rotateEl: '.mi-rotate', /* same key as header, but diff class */
            fullScreenLbl: '.mi-fs-lbl',
            downloadSubMenuItem: '.mi-download',

            pdfComboNewWindow:  '#pdfComboLink',
            pdfComboDL:         '#pdfComboDL',

            addPg:          '#mi-add-page',
            deletePg:       '#mi-delete-page',
            reorderPgs:     '#mi-reorder-pages',

            launchDocAsPdf: '#launchDocAsPdf'

        },
        _.pick(HeaderCenterView.prototype.ui, 'fullScreenToggleBtn', 'fullScreenIcon')
    ),
    events: function() {

        var vCh = this.options.vChannel;

        return {
            /*
             * TODO:
             * - really incorp into main class but here for now -- would need to extend for all
             * - note -- would need the class, not inherited via css -- derive something from calc'd prop's if make generic
             * StopImmediatePropagation: prevent other handlers, not just bubbling
             */
            'click .mi': function(e) {
                $(e.target).hasClass('disabled') && e.stopImmediatePropagation();
            },
            'click @ui.showDocInfo':            _.bind(vCh.command, vCh, 'showDocInfo'),
            'click @ui.showPgInfo':             _.bind(vCh.command, vCh, 'showPgInfo'),

            'click @ui.showAbout':              _.bind(vCh.command, vCh, 'showAbout'),
            'click @ui.popWindow':              _.bind(vCh.command, vCh, 'openInNewWindow'),
            'click @ui.launchDocAsPdf':         _.bind(vCh.command, vCh, 'openDocAsPdfInNewWindow'),

            'click @ui.fullScreenToggleBtn':    _.bind(vCh.command, vCh, 'toggleFullScreenMode'),
            'click @ui.nextPg':                 _.bind(vCh.command, vCh, 'goNextPage'),
            'click @ui.prevPg':                 _.bind(vCh.command, vCh, 'goPrevPage'),
            'click @ui.firstPg':                _.bind(vCh.command, vCh, 'goToFirstPage'),
            'click @ui.lastPg':                 _.bind(vCh.command, vCh, 'goToLastPage'),

            /* note: could mixin from zoom view events -- (common dom el names, etc) */
            'click @ui.zoomIn':                 _.bind(vCh.command, vCh, 'zoomIn'),
            'click @ui.zoomOut':                _.bind(vCh.command, vCh, 'zoomOut'),

            'click @ui.dlDocPDF':               _.bind(vCh.command, vCh, 'download', 'document', 'PDF'),
            'click @ui.dlDocRaw':               _.bind(vCh.command, vCh, 'download', 'document', 'raw'),

            'click @ui.pdfComboDL':             _.bind(vCh.command, vCh, 'exportAllDocumentsAsPDF', 0), /* put 0 in explicity, otherwise e is passed */
            'click @ui.pdfComboNewWindow':      _.bind(vCh.command, vCh, 'exportAllDocumentsAsPDF', 1),

            'click @ui.deletePg': function() {
                // note: don't use '_.bind(vCh.command, vCh, 'showDeletePageDialog')' shorthand
                //( avoid passing event argument that's appended by _.bind)
                vCh.command('showDeletePageDialog');
            },

            'click @ui.addPg':                  _.bind(vCh.command, vCh, 'showAddPagesDialog'),
            'click @ui.reorderPgs':             _.bind(vCh.command, vCh, 'showReorderPagesDialog'),


            'click @ui.dlPgPDF': function(e) {
                if ($(e.target).hasClass('disabled'))
                    return false;
                vCh.command('download', 'page', 'PDF');
            },
            'click @ui.dlPgRaw': function() {
                vCh.command('download', 'page', 'RAW'); //! -- not BIND form. b/c passes the event param in the arguments object, which isn't wanted by download dispatcher
            },
            'click @ui.rotatePg': function(e) {
                vCh.request('rotatePgRequest', $(e.target).data().deg);
            },
            onClickExportPDF: function() {
                this.options.vChannel.command('exportAllDocumentsAsPDF');
            },

            'click @ui.showPageText': function(e) {

                var $target =  $(e.currentTarget);

                // TODO: -- do I check this now in lower level plugin?
                if ( $target.hasClass('disabled') )
                    return false;

                // TODO: also in use with COLD page action menu -- check for class and make common functionality
                $target.toggleClass('active');

                vCh.command('toggleShowPageTextMode');

            },

            'click @ui.textOnlyMode': function(e) {

                var $target =  $(e.currentTarget);

                if ( $target.hasClass('disabled') )
                    return false;

                $target.toggleClass('active');

                vCh.command('toggleTextOnlyMode');

            }


        };
    },
    onToggleFullScreen: function(isFullScreen) {
        HeaderCenterView.prototype.onToggleFullScreen.apply(this, arguments);
        this.ui.fullScreenLbl.text(isFullScreen ? 'Resize' : 'Full Screen');
    },
    //TODO: COMBO WITH toggleHeaderViewModeState
    updatePostPageChange: function(opts) {

        this.setNavFormatting(opts.isFirstPg, opts.isLastPg);
        this.toggleRotateEnabled(opts.disableRotation);
        this.toggleScaleEnabled(opts.disableScaling);
        this._togglePageDownloadEnabled(opts.page);

    },
    setNavFormatting: function(isFirstPage, isLastPage) {

        var $el = this.$el;
        $el.removeClass('firstPg lastPg');

        if (isFirstPage)
            $el.addClass('firstPg');

        if (isLastPage)
            $el.addClass('lastPg');

    },

    /**
     *
     * currentPage predicate required in case doc has no pages
     * If URL page: OLD disable entire dl submenu ( any doc download request will fail b/c its page request will fail )
     * New: all for failure and provide error message; this should be fixed in CRE, esp for doc with mixed pages.
     */

    _togglePageDownloadEnabled: function(currentPage) {

        var vCh = this.options.vChannel;

        this.ui.dlPgRaw.toggleClass('disabled', !currentPage || !vCh.request('allowPageDownload', currentPage) ) ;
        this.ui.dlPgPDF.toggleClass('disabled', !currentPage || !vCh.request('allowPageDownload', currentPage, 1) ) ;

    },
    toggleRotateEnabled: function() {
        HeaderCenterView.prototype.toggleRotateEnabled.apply(this, arguments); //(needs cxt)
    },
    toggleScaleEnabled: function(disable) {
        this.ui.zoomIn.add(this.ui.zoomOut).toggleClass('disabled', disable);
    },
    setDisableHandlers: RotateView.prototype.setDisableHandlers,
    toggleHeaderViewModeState: HeaderCenterView.prototype.toggleHeaderViewModeState
});





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerRight/overflowMenu/headerOverflow.js
 ** module id = 738
 ** module chunks = 0
 **/